/*
 * Copyright (c) ProviderTrust LLC.
 * All Rights Reserved.
 *
 * This software is confidential and proprietary information of
 * ProviderTrust LLC ("Confidential Information"). You shall not disclose
 * such Confidential Information and shall use it only in
 * accordance with the terms of the license agreement you entered
 * into with ProviderTrust.
 */

export function transposeArray(arry) {
  if (arry) {
    return arry.length ? arry[0].map((col, i) => arry.map(row => row[i])) : []
  }
}

export function dedupeArry(arry) {
  if (arry) {
    return [...new Set(arry)]
  }
}

export function deleteElFromArry(arry, el) {
  const indx = arry.indexOf(el)
  if (indx === -1) return false

  arry.splice(indx, 1)
  return true
}



// WEBPACK FOOTER //
// ./src/service/util.js